<template>
  <div class="top">
    <div class="eyecatch">
      <div class="info-description">
        <h2>
          <span>M</span>alabaristas<br>
          <span>J</span>uggling<br>
          <span>F</span>esitval<br>
          <span>2018</span>
        </h2>
        <p>2018.09.02(Sun.)</p>
      </div>
      <div class="slide">
        <img src="https://i.imgur.com/FoPzyH3.jpg" @load="increment" />
      </div>
      <div class="slide">
        <img src="https://i.imgur.com/HKseXMs.jpg" @load="increment" />
      </div>
      <div class="slide">
        <img src="https://i.imgur.com/r4rTG7D.jpg" @load="increment" />
      </div>
      <div class="slide">
        <img src="https://i.imgur.com/868UERb.jpg" @load="increment" />
      </div>
    </div>
    <div class="about section" v-show-scroll="{scrollY: scrollY, windowHeight: windowHeight}" id="about">
      <div class="container">
        <h2 class="section-head">MJFとは</h2>
        <div class="about-description">
          <p>MJF(Malabaristas Juggling Festival)は、年に一度、マラバリスタの会員が日頃の練習の成果を披露し、その技術力・表現力を競い合う唯一の部内大会です。</p>
          <p>五月祭や駒場祭でのステージとは異なり屋内での開催であるため、特殊な照明効果を用い自分好みの演出ができるステージでもあります。</p>
          <p>今年で23回目を迎える伝統的な大会では、ジャグリング経験1年未満のジュニア部門と1年以上のシニア部門に分かれ、審査員5名と観客の皆様も交えて審査を行います。</p>
          <p>MJF 2018は以下の日程で開催予定です。</p>
        </div>
        <div class="description-detail">
          <ul>
            <li>
              <span class="marker-line gray">開催日</span>
              ：2018年9月2日（日）</li>
            <li>
              <span class="marker-line gray">開場</span>
              ：14時30分</li>
            <li>
              <span class="marker-line gray">開演</span>
              ：15時00分</li>
            <li>
              <span class="marker-line gray">会場</span>
              ：東京大学駒場キャンパス 多目的ホール（駒場小空間）</li>
          </ul>
        </div>
      </div>
      <div class="english-title right">
        ABOUT MJF
      </div>
    </div>
    <div class="players section" id="players">
      <div class="players-box">
        <div class="container">
          <h2 class="section-head blue">出場者</h2>
          <div class="player-container">
            <div class="class-container" v-show-scroll="{scrollY: scrollY, windowHeight: windowHeight}">
              <h3 class="judge-name">ジュニア部門</h3>
              <p>ジャグリング歴1年未満の部門です。</p>
              <div class="player" v-for="player in players.junior" :key="player.id">
                <p>
                  <span class="player-name">{{player.name}}</span>
                  <span class="prize" v-if="player.prize">
                    {{player.prize}}
                  </span>
                  <img class="instrument-image" :src="player.image" />
                  {{player.instrument}}
                </p>
              </div>
            </div>
            <div class="class-container" v-show-scroll="{scrollY: scrollY, windowHeight: windowHeight}">
              <h3 class="judge-name">シニア部門</h3>
              <p>ジャグリング歴1年以上の部門です。</p>
              <div class="player" v-for="player in players.senior" :key="player.id">
                <p>
                  <span class="player-name">{{player.name}}</span>
                  <span class="prize" v-if="player.prize">
                    {{player.prize}}
                  </span>
                  <img class="instrument-image" :src="player.image" />
                  {{player.instrument}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="players-pictures" v-picttop="{scrollY: scrollY, windowHeight: windowHeight, clicked: $store.state.clickedNav}">
        <img src="https://i.imgur.com/8E1whwq.jpg" />
        <img src="https://i.imgur.com/QmyESjB.jpg" />
        <img src="https://i.imgur.com/Mb1rMFp.jpg" />
      </div>
      <div class="english-title left white">
        PLAYERS
      </div>
    </div>
    <div class="criterion section" v-show-scroll="{scrollY: scrollY, windowHeight: windowHeight}" id="criterion">
      <div class="container">
        <h2 class="section-head blue">審査基準</h2>
        <div>
          <p>各審査員は、以下の4つの要素を考慮しつつ、100点満点で審査を行うものとします。</p>
          <div class="flex">
            <div class="criteria" v-for="criteria in criterion" :key="criteria.name">
              <div class="criteria-star">
                <h4>{{criteria.name}}</h4>
              </div>
              <p v-html="criteria.description"></p>
            </div>
          </div>
          <p>各審査員による採点の合計点によって順位を決定し、表彰を行います。</p>
          <p>各部門における表彰の範囲については組数に応じて以下のようにいたします。</p>
          <div class="description-detail black">
            <ul>
              <li>
                <span class="marker-line">6組以上</span>
                ：3位まで</li>
              <li>
                <span class="marker-line">4,5組</span>
                ：2位まで
              </li>
              <li>
                <span class="marker-line">3組以下</span>
                ：1位のみ
              </li>
            </ul>
          </div>
          <p>また、観客の投票によって決まる「観客賞」を全部門から1組選出します。</p>
        </div>
        <div class="english-title right orange">
          CRITERION
        </div>
      </div>
    </div>
    <div class="judges section" id="judges">
      <div class="img-container" v-picttop="{scrollY: scrollY, windowHeight: windowHeight, clicked: $store.state.clickedJudges}">
      </div>
      <div class="container">
        <h2 class="section-head blue">審査員</h2>
        <div class="judge" v-for="judge in judges" :key="judge.name" v-show-scroll="{scrollY: scrollY, windowHeight: windowHeight}">
          <h3 class="judge-name">{{judge.name}}</h3>
          <img class="judge-image" :src="judge.image" />
          <p class="description">{{judge.description}}</p>
        </div>
        <div class="english-title left orange">
          JUDGES
        </div>
      </div>
    </div>
    <div class="guests section" id="guests">
      <div class="container">
        <h2 class="section-head">ゲストステージ</h2>
        <div class="judge" v-show-scroll="{scrollY: scrollY, windowHeight: windowHeight}" v-for="guest in guests" :key="guest.name">
          <h3 class="judge-name black">{{guest.name}}</h3>
          <img class="judge-image" :src="guest.image" />
          <p class="description">{{guest.description}}</p>
        </div>
        <div class="english-title right">
          GUEST
        </div>
      </div>
    </div>
    <div class="notice section" id="notice">
      <div class="container">
        <h2 class="section-head blue">お知らせ</h2>
        <dl>
          <dt class="dt">8月13日</dt>
          <dd>サイトを公開しました。</dd>
        </dl>
        <p class="text-red">当日は会場のトイレが工事により使えません。付近の建物のトイレをご利用いただくようお願いいたします。</p>
      </div>
    </div>
    <div class="access section" id="access">
      <div class="container">
        <h2 class="section-head blue">アクセス</h2>
        <p>会場：東京大学駒場キャンパス内、駒場小空間（多目的ホール）</p>
        <p>京王井の頭線 駒場東大前駅下車、東口より徒歩5分</p>
      </div>
    </div>
    <div class="contact" id="contact">
      <div class="container">
        <h2 class="section-head blue">お問い合わせ</h2>
        <p>MJFの開催に関するお問い合わせ、または当サイトに関するお問い合わせは、以下のアドレスまでお願いします。</p>
        <div class="description-detail black">
          <p>
            <span class="marker-line">E-mail</span>
            : mjf2018staff[ATMARK]gmail.com
          </p>
          <p>
            <span class="marker-line">担当者</span>
            ：石野 耀久(運営責任者)・野間 裕太(ウェブサイト管理)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {criterion, players, judges, guests} from '../data/data'
export default {
  name: 'Main',
  data () {
    return {
      scrollY: 0,
      windowHeight: window.innerHeight,
      criterion: criterion,
      players: players,
      judges: judges,
      guests: guests
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleScroll () {
      this.scrollY = window.scrollY
      setTimeout(() => {
        this.$store.commit('falsen')
        this.$store.commit('falsenJudges')
      }, 100)
    },
    handleResize () {
      this.windowHeight = window.innerHeight
    },
    increment () {
      this.$store.commit('increment')
    }
  },
  directives: {
    picttop: {
      update (el, binding, oldValue) {
        const offset = el.getBoundingClientRect().top
        el.style.transform = 'translateY(' + (-offset) / 2 + 'px)'
        if (binding.value.clicked === true) {
          el.style.transform = 'translateY(0px)'
        }
      }
    },
    showScroll: {
      update (el, binding) {
        const offset = el.getBoundingClientRect().top
        if (offset < binding.value.windowHeight - 150) {
          el.classList.add('active')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/base.scss";

.top {
  width: 100%;
  padding-bottom: 50px;
}
.container {
  width: 85%;
  margin: 0 auto;
  @media screen and (min-width: 800px) {
    width: 720px;
    margin: 0 auto;
  }
}
.description {
  white-space: pre-line;
}
.section {
  padding: 10px 0 20px;
  position: relative;
  transition: all 0.5s;
  &.players {
    padding: 0;
  }
}
.section-head {
  display: table;
  padding-left: 60px;
  padding-right: 60px;
  margin: 20px auto;
  position: relative;
  &:after {
    position: absolute;
    content: "";
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, $orange 0%, $orange 30%, $white 30%, $white 60%, rgba(255, 255, 255, 0) 100%);
  }
  &.blue:after {
    background: linear-gradient(to right, $orange 0%, $orange 30%, $blue2 30%, $blue2 60%, rgba(255, 255, 255, 0) 100%);
  }
}
.english-title {
  position: absolute;
  font-size: 70px;
  top: 20px;
  writing-mode: vertical-rl;
  opacity: 0.5;
  font-family: 'Maven Pro', sans-serif;
  letter-spacing: 0.05em;
  visibility: hidden;
  &.right {
    right: 20px;
  }
  &.left {
    left: 20px;
  }
  &.orange {
    color: $orange;
  }
  &.white {
    opacity: 0.5;
    color: $white;
  }
  @media screen and (min-width: 800px) {
    visibility: visible;
  }
}
.description-detail {
  display: table;
  position: relative;
  padding: 5px 30px;
  border: 2px solid $white;
  margin: 20px auto;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.15);
  &.black {
    border-color: $black;
    background-color: $white;
  }
}
.flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

$duration: 28s;

.eyecatch {
  height: 100vh;
  overflow: hidden;
  position: relative;
  background-color: $black;
  .slide {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: all 0.5s;
    transition-delay: 0.3s;
    transition-timing-function: ease-in-out;
    animation-name: slideshow;
    animation-duration: $duration;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    opacity: 0;
    &:before, &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      animation-name: slideshow-before;
      animation-duration: $duration;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }
    &:before {
      background-color: $blue2;
    }
  }
  img {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
    animation-name: slideshow-image;
    animation-duration: $duration;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
  .slide:nth-of-type(2) {
    animation-delay: $duration / 4;
    img, &:before {
      animation-delay: $duration / 4;
    }
  }
  .slide:nth-of-type(3) {
    animation-delay: $duration / 2;
    img, &:before {
      animation-delay: $duration / 2;
    }
  }
  .slide:nth-of-type(4) {
    animation-delay: $duration * 3 / 4;
    img, &:before {
      animation-delay: $duration * 3 / 4;
    }
  }
}
@keyframes slideshow {
  0% {
    opacity: 1;
    transform: translateX(105%);
    z-index: 100;
  }
  2% {
    transform: translateX(105%);
  }
  8% {
    transform: translateX(0);
  }
  35% {
    transform: translateX(0);
    z-index: 50;
  }
  40% {
    z-index: -100;
  }
  50% {
    transform: translateX(105%);
  }
  100% {
    opacity: 1;
    transform: translateX(105%);
    z-index: 100;
  }
}
@keyframes slideshow-before {
  1% {
    transform: translateX(0);
  }
  7% {
    transform: translateX(-100%);
  }
  10% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes slideshow-image {
  0% {
    transform: scale(1.1);
  }
  7% {
    transform: scale(1.1);
  }
  35% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1)
  }
}
.info-description {
  color: $white;
  opacity: 0.8;
  font-family: 'Montserrat Subrayada', sans-serif;
  z-index: 1000;
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  text-align: center;
  h2 {
    font-size: 26px;
    margin: 10px 0;
    span {
      color: $orange;
      font-size: 32px;
    }
  }
  p {
    font-size: 20px;
    margin: 5px 0;
  }
  @media screen and (min-width: 800px) {
    top: auto;
    left: auto;
    bottom: 30px;
    right: 50px;
    h2 {
      font-size: 40px;
      span {
        font-size: 50px;
      }
    }
    p {
      font-size: 30px;
    }
  }
}

.about {
  background-color: $gray;
  color: $white;
  position: relative;
  transform: translateX(100%);
  transition: all 1s;
  transition-delay: 0.3s;
  transition-timing-function: linear;
  .container {
    opacity: 0;
    transition: all 1s;
    transition-delay: 1.5s;
    transform: translateY(70px);
  }
  .english-title {
    opacity: 0;
    transition: all 1s;
    transition-delay: 1.3s;
  }
  &:before, &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: all 1s;
  }
  &:before {
    transform: translateX(-100%);
    background-color: $orange;
  }
  &:after {
    transform: translateX(0);
    background-color: $white;
    transition-timing-function: ease-in-out;
  }
  &.active {
    transform: translateX(0);
    &:after {
      transform: translateX(-100%);
    }
    .container {
      opacity: 1;
      transform: translateY(0);
    }
    .english-title {
      opacity: 0.5;
    }
  }
}

.players {
  color: $black;
  display: flex;
  justify-content: flex-end;
  position: relative;
  overflow: hidden;
}
.players-box {
  background-color: $white;
  width: 100%;
  border-top: 10px solid $blue3;
  border-bottom: 10px solid $blue3;
  @media screen and (min-width: 800px) {
    width: 70%;
    overflow: hidden;
    .container {
      width: 90%;
    }
  }
}
.players-pictures {
  position: absolute;
  left: 0;
  width: 30%;
  display: none;
  @media screen and (min-width: 800px) {
    display: block;
  }
  img {
    display: block;
    position: relative;
    width: 100%;
    top: 0;
  }
}
.class-container {
  transform: translateY(100px);
  transition: 1s all;
  opacity: 0;
  &.active {
    transform: translateY(0);
    opacity: 1;
  }
}
.player:last-of-type {
  margin-bottom: 30px
}
.player-name {
  font-size: 1.1em;
  font-weight: bold;
}
.instrument-image {
  max-height: 50px;
  width: 40px;
  transform: translateY(10px);
  margin: 0 10px;
}

.criterion {
  background-color: $lightgray;
}
.criteria {
  width: 300px;
  margin: 10px;
  padding: 10px;
  padding-bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
  box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.1);
}
.criteria-star {
  background-image: url('https://i.imgur.com/FTG6dnb.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  h4 {
    text-align: center;
    color: $white;
    padding-top: 20px;
    padding-left: 22px;
    padding-right: 22px;
    font-size: 14px;
  }
}
.criterion.active {
  .criteria-star {
    animation-name: star;
    animation-duration: 0.3s;
    animation-delay: 1s;
    animation-iteration-count: 2;
  }
}
@keyframes star {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(40deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
.criteria:last-of-type {
  .criteria-star {
    h4 {
      font-size: 10px;
    }
  }
}

.guests {
  background-color: $black;
  color: $white;
}

.judges {
  overflow: hidden;
  color: $black;
}
.img-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url('https://i.imgur.com/eo1VrNv.png');
  background-size: 400px;
  &:before {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(250, 250, 250, 0.9);
  }
}
.judge {
  margin: 30px auto;
  transform: translateY(70px);
  opacity: 0;
  transition: all 1s;
  &.active {
    transform: translateY(0);
    opacity: 1;
  }
}
.judge-name {
  position: relative;
  display: table;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 50px;
  background-color: $lightgray;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.3);
  &:after {
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 0;
    border-width: 16px 16px 0 0;
    border-style: solid;
    border-color: transparent $blue $blue transparent;
  }
  &.black {
    background-color: $gray;
    &:after {
      border-color: transparent $blue $blue transparent;
    }
  }
}
.judge-image {
  max-width: 90%;
  max-height: 350px;
}

.dt {
  display: table;
  margin: 5px auto;
  padding: 5px 20px;
  border-bottom: 2px dotted $blue;
  font-weight: bold;
}

.text-red {
  color: $orange;
  font-weight: bold;
}

.prize {
  color: $orange;
  margin-left: 5px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue